// material-ui
import {Grid, Typography, Stack, Box} from '@mui/material';
import MainCard from "../../../Components/MainCard";
import Plans from "../../../assets/images/getting-started/subscribinginfo/plans.png"
import UserAddOns from "../../../assets/images/getting-started/subscribinginfo/UserAddOns.png"
import SelectPlan from "../../../assets/images/getting-started/subscribinginfo/SelectPlan.png"
import SignUpSuccess from "../../../assets/images/getting-started/subscribinginfo/SignupSuccess.png"
import SelectOrganisationPlanUpdate from "../../../assets/images/getting-started/subscribinginfo/SelectOrganisationUpdate.png"
import EditProfilePage from "../../../assets/images/getting-started/subscribinginfo/EditProfilePage.png"
import MultiEditProfile from "../../../assets/images/getting-started/subscribinginfo/MultiEditProfile.png"
import ProfilePaymentTab from "../../../assets/images/getting-started/subscribinginfo/ProfilePaymentTab.png"
import ConfirmPlan from "../../../assets/images/getting-started/subscribinginfo/ConfirmPlan.png"
import ModifyUserAddOn from "../../../assets/images/getting-started/subscribinginfo/ModifyUserAddOn.png"
import UpgradePlan from "../../../assets/images/getting-started/subscribinginfo/UpgradePlan.png"
import ConfirmMultiOrg from "../../../assets/images/getting-started/subscribinginfo/ConfirmMultiOrg.png"
import ConfirmSubscription from "../../../assets/images/getting-started/subscribinginfo/ConfirmMultiPlan.png"
import XeroIntegrations from "../../../assets/images/getting-started/subscribinginfo/XeroIntegrations.png"
import XeroIntegrationSignIn from "../../../assets/images/getting-started/subscribinginfo/XeroIntegrationSignin.png"
import XeroOrgSelect from "../../../assets/images/getting-started/subscribinginfo/XeroOrgSelect.png"
import AddUser from "../../../assets/images/getting-started/subscribinginfo/AddUser.png";

function SubscribingInfo(){
    return (
        <MainCard>
        <Stack spacing={2.5}>
            <Typography variant="h4">
                Before Purchasing a Plan
            </Typography>
            <Typography variant="body1">
                Once a plan is purchased the Ikigai application will use the credentials of the person that
                purchased the plan to interact with Xero API. In order to get the best user experience please
                ensure the person purchasing the plan has Adviser role.

                If you have signed up with a user with insufficient role please contact our team.
            </Typography>
            <Typography variant="h4">
                Purchasing a Plan
            </Typography>
            <Typography variant="body1">
                To purchase a plan follow the steps below:
            </Typography>
            <Typography variant="body1">
                1. Navigate to https://ikigai.passionit.tech/signup-with-xero
            </Typography>
            <Typography variant="body1">
                2. You will need to sign into Xero and select the Organisation you want to purchse the plan for.
            </Typography>
            <Typography variant="body1">
                3. Select the plan you would like to purchase for your Organisation.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={Plans} alt="Select Ikigai Plan" />
                </Box>
            </Typography>
            <Typography variant="body1">
                4. You will be redirected to Xero App Store where you need to select which plan to purchase. Please note images are using DEMO environment and does not reflect actual pricing.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={SelectPlan} alt="Select Plan to purchase" />
                </Box>
            </Typography>
            <Typography variant="body1">
                5. If you require user Add Ons you can do so before purchasing via the Xero App Store. Please note images are using DEMO environment and does not reflect actual pricing.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={UserAddOns} alt="User Add Ons" />
                </Box>
            </Typography>
            <Typography variant="body1">
                6. Navigate back to Ikigai website upon purchasing of plan. You will be redirected to a successful sign up page. You must navigate to this page in order for a user to be created and for the platform to confirm successful sign up.
                If you do not have an existing account with Ikigai a new account will be created and temporary credentials will be sent to your e-mail (same as the e-mail used for Xero). If you already have an existing account with Ikigai a new subscription will be added to your profile.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={SignUpSuccess} alt="Sign Up Success" />
                </Box>
            </Typography>
            <Typography variant="h4">
                Plans
            </Typography>
            <Typography variant="h5">
                Single Organisation Plan
            </Typography>
            <Typography variant="body1">
                The Single Organisation Plan is ideal for users with only 1 Xero Organisation and a small number of employees.
                This plan provides access to all of the same features as Multi Organisation Plan.
                The only difference is that this plan cannot add additional Xero Organisations to the subscription. Also,
                the plan comes with 1 user included. If you require more users to access Ikigai you will need to purchase
                user add-ons. Additional add-ons may be added in future as new features and functionality is developed.
            </Typography>
            <Typography variant="h6">
                Purchasing User Add-Ons
            </Typography>
            <Typography variant="body1">
                Once you have logged in you can navigate to your subscription management screen by doign the following steps:
            </Typography>
            <Typography variant="body1">
                1. Select the Xero Organisation you would like to add additional Users to.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={SelectOrganisationPlanUpdate} alt="Select Subscription" />
                </Box>
            </Typography>
            <Typography variant="body1">
                2. Navigate to the Edit Profile page.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={EditProfilePage} alt="Edit Profile" />
                </Box>
            </Typography>
            <Typography variant="body1">
                3. Click the payment tab and click the manage subscription button.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ProfilePaymentTab} alt="Profile Payment Tab" />
                </Box>
            </Typography>
            <Typography variant="body1">
                4. In the Xero App Store click Confirm plan button. Please note images are using DEMO environment and does not reflect actual pricing.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ConfirmPlan} alt="Confirm Plan" />
                </Box>
            </Typography>
            <Typography variant="body1">
                5. Select the number of User Add Ons you require. Please note images are using DEMO environment and does not reflect actual pricing. If you are decreasing the number of user add ons it will
                cause the following to happen:
                <Typography variant="body1">
                a. all users except the subscription owner will be removed from the subscription.
                </Typography>
                <Typography variant="body1">
                b. Users and their roles within Ikigai will need to be re-added back onto the subscription.
                </Typography>
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ModifyUserAddOn} alt="Select number of Add Ons" />
                </Box>
            </Typography>
            <Typography variant="h6">
                Upgrading your Plan
            </Typography>
            <Typography variant="body1">
                As your business grows you might be in a situation where it is more economical to upgrade your plan to
                suit your business needs. For example you have additional Xero Organisations or the number of users you
                would like access to Ikigai has reached the point where it is cheaper to upgrade your plan to enable more
                users (999,999) instead of purchasing additional add-ons.
            </Typography>
            <Typography variant="body1">
                In order to upgrade your plan follow the following steps:
            </Typography>
            <Typography variant="body1">
                1. Select the Xero Organisation you would like to add additional Users to.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={SelectOrganisationPlanUpdate} alt="Select Subscription" />
                </Box>
            </Typography>
            <Typography variant="body1">
                2. Navigate to the Edit Profile page.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={EditProfilePage} alt="Edit Profile" />
                </Box>
            </Typography>
            <Typography variant="body1">
                3. Click the payment tab and click the manage subscription button.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ProfilePaymentTab} alt="Profile Payment Tab" />
                </Box>
            </Typography>
            <Typography variant="body1">
                4. Select the Multi Organisation Plan from the Xero App Store. Click on Confirm plan.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={UpgradePlan} alt="Upgrade Plan" />
                </Box>
            </Typography>
            <Typography variant="body1">
                5. Confirm you would like to proceed with upgrading by clicking Continue.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ConfirmMultiOrg} alt="Confirm Multi Organisation Plan" />
                </Box>
            </Typography>
            <Typography variant="body1">
                6. Confirm you would like to change subscription by clicking Confirm.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ConfirmSubscription} alt="Confirm Subscription Change" />
                </Box>
            </Typography>
            <Typography variant="h5">
                Multi Organisation Plan
            </Typography>
            <Typography variant="body1">
                The Multi Organisation Plan is ideal for users with multiple Xero Organisations such as Accountants and Bookkeepers.
                This plan provides the ability to connect with multiple Xero Organisations giving a high level overview of an organisation via a few clicks.
                This plan also provides subscription owners with the ability to add 10 users onto their plan,
                if more users are required this plan takes advantage of purchasing bulk user add-ons at a discount.
            </Typography>
        </Stack>
            </MainCard>
    )
}

export default SubscribingInfo;